import { getTheme, IStyle, mergeStyleSets } from "@fluentui/react";

export const getPageStyles = () => {
    const theme = getTheme();

    const main: IStyle = {
        flexGrow: 1,
        backgroundColor: theme.palette.neutralLighterAlt,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const signInPanel: IStyle = {
        width: 440,
        padding: 40,
    };

    const header: IStyle = {
        fontSize: 24,
        fontWeight: 'bold',
        margin: 0,
        padding: 0,
    };

    const boldText: IStyle = {
        fontWeight: 'bold',
    };

    const loginFailText: IStyle = {
        fontWeight: 'bold',
        color: theme.semanticColors.errorIcon,
    };

    return mergeStyleSets({
        main,
        signInPanel,
        header,
        boldText,
        loginFailText,
    });
}